import { colors } from '@globals/themes/defaultTheme'
import { onHover, semiBoldFontWeight } from '@globals/themes/themeConstants'
import useMemberProfileRoute from '@globals/useMemberProfileRoute'
import Box from '@mui/material/Box'
import { SxProps } from '@mui/material/styles'
import React, { useCallback } from 'react'
import { useNavigate } from 'react-router'
import HtmlContent from '../HtmlContent'
import MentionsPopper from './MentionsPopper'
import { useHtmlContentWithMentions } from './useHtmlContentWithMentions'

export const HtmlContentStyle: SxProps = {
  overflowWrap: 'anywhere',
  '& span[data-type="mention"]': {
    fontWeight: semiBoldFontWeight,
    color: colors.bluePrimary,
    [onHover]: {
      cursor: 'pointer',
    },
  },
  '& > p': {
    marginBlockStart: 0,
  },
  '& > p:last-child': {
    marginBlockEnd: 0,
  },
}

type HtmlContentWithMentionsProps = {
  htmlContent: string
  height?: number | string
  maxHeight?: number | string
}

const HtmlContentWithMentions: React.FC<HtmlContentWithMentionsProps> = ({
  htmlContent,
  height = '100%',
  maxHeight = '100%',
}) => {
  const navigate = useNavigate()
  const getMemberProfileRoute = useMemberProfileRoute()

  const onNavigate = useCallback(
    (id: string) => navigate(getMemberProfileRoute(id)),
    [navigate, getMemberProfileRoute],
  )

  const { containerRef, anchorEl, tenantMemberId, setPreviewLoading } = useHtmlContentWithMentions({
    htmlContent,
    onNavigate,
  })

  return (
    <Box ref={containerRef} sx={{ height, overflow: 'auto', maxHeight }}>
      <HtmlContent htmlContent={htmlContent} sx={HtmlContentStyle} />
      {tenantMemberId && (
        <MentionsPopper
          tenantMemberId={tenantMemberId}
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onPreviewLoadingChange={setPreviewLoading}
        />
      )}
    </Box>
  )
}

export default HtmlContentWithMentions
